/** @format */

import {Box, Typography} from '@mui/material';
import {styled} from '@mui/material/styles';

const StyledBox = styled(Box)(({theme}) => ({
  marginTop: theme.spacing(1),
  paddingLeft: theme.spacing(1),
}));

const StyledErrorText = styled(Typography)(() => ({
  color: '#f00',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '16px',
}));

type Props = {
  text: string;
};

const ErrorMessage = ({text}: Props) => {
  return (
    <StyledBox data-testid='error-message'>
      <StyledErrorText>{text}</StyledErrorText>
    </StyledBox>
  );
};

export default ErrorMessage;
